import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  firmwareRequest: ['id'],
  firmwareAddRequest: ['data'],
  firmwareUpdateRequest: ['data'],

  firmwareFileAddRequest: ['id', 'formData'],
  firmwareFileDownloadRequest: ['id', 'fileName'], 
  firmwareFileDownloadSuccess: ['fileLink'],
  firmwareFileDownloadFailure: ['error'],

  updateFirmwareWithFile: ['data', 'file'],

  firmwareCommentGetRequest: ['id'],
  firmwareCommentAddRequest: ['id', 'data'],
  firmwareDeleteRequest: ['id'],
  firmwareCommentSuccess: ['data'],
  firmwareCommentAddSuccess: ['data'],
  firmwareCommentFailure: ['data'],
  firmwareSuccess: ['data'],
  firmwareFailure: ['error'],
});

export const FirmwareTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  firmware: null,
  comments: null,
  error: null,
  fetching: false,
  commentFetching: false,
});

/* ------------- Reducers ------------- */

/// Main firmware model
export const request = state => state.merge({ fetching: true });

export const failure = (state, { error }) =>
  state.merge({ fetching: false, error });

export const success = (state, { data }) =>
  state.merge({ fetching: false, error: null, firmware: data });

/// comments
export const commentsSuccess = (state, { data }) =>
  state.merge({ commentFetching: false, error: null, comments: data });

export const commentFailure = (state, { error }) =>
  state.merge({ commentFetching: false, error });

export const commentAddSuccess = (state, {data}) =>
  state.merge({ commentFetching: false, error: null});

export const commentRequest = (state) =>
  state.merge({ commentFetching: true});

//file

export const fileDownloadRequest = (state) => state.merge({ fetching: true });

export const fileDownloadSuccess = (state, { fileLink }) =>
  state.merge({ fetching: false, error: null, file: fileLink });

export const fileDownloadFailure = (state, { error }) =>
  state.merge({ fetching: false, error });


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FIRMWARE_REQUEST]: request,
  [Types.FIRMWARE_ADD_REQUEST]: request,
  [Types.FIRMWARE_UPDATE_REQUEST]: request,
  [Types.FIRMWARE_DELETE_REQUEST]: request,
  [Types.FIRMWARE_SUCCESS]: success,

  [Types.UPDATE_FIRMWARE_WITH_FILE]: success,


  [Types.FIRMWARE_FILE_ADD_REQUEST]: fileDownloadRequest,
  [Types.FIRMWARE_FILE_DOWNLOAD_REQUEST]: fileDownloadRequest,
  [Types.FIRMWARE_FILE_DOWNLOAD_SUCCESS]: fileDownloadSuccess,
  [Types.FIRMWARE_FILE_DOWNLOAD_FAILURE]: fileDownloadFailure,
  
  [Types.FIRMWARE_COMMENT_GET_REQUEST]: commentRequest,
  [Types.FIRMWARE_COMMENT_ADD_REQUEST]: commentRequest,
  [Types.FIRMWARE_COMMENT_SUCCESS]: commentsSuccess, 
  [Types.FIRMWARE_COMMENT_ADD_SUCCESS]: commentAddSuccess,
  [Types.FIRMWARE_COMMENT_FAILURE]:commentFailure
});
